import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { withLDConsumer } from 'launchdarkly-react-client-sdk'

import { BasicModal } from '@/components/layout/modals/BasicModal'
import { AbstractForm } from '@/components/forms/formik/AbstractForm'
import { closeModal } from '@/reducers/ui/ui.redux'
import { patchUser } from '@/reducers/organizations/organizationUsers.actions'
import { fetchCurrentUserPermissions } from '@/reducers/auth/currentUser.actions'

const jobFunctionOptions = [
  {
    value: 'supervisor',
    label: 'Supervisor/Agent Manager',
    description: 'You directly manage agents and provide coaching',
  },
  {
    value: 'qa',
    label: 'QA/Compliance',
    description: 'You perform quality assurance or compliance monitoring',
  },
  {
    value: 'executive',
    label: 'Executive',
    description: 'VP, Director, or C-level leadership',
  },
  {
    value: 'it',
    label: 'IT Admin',
    description: 'You manage system setup and configuration',
  },
  {
    value: 'agent',
    label: 'Agent',
    description: 'You take calls and interact with customers',
  },
]

export const MetricsJobFunctionModalComponent = ({ flags = {} }) => {
  const dispatch = useDispatch()
  const { currentlyOpenModalId } = useSelector((state) => state.ui)
  const {
    user_id: userId,
    organizationid,
    own_organization_id,
    first_name: firstName,
    last_name: lastName,
    metrics_job_function: metricsJobFunction,
  } = useSelector((state) => state.currentUser)

  const modalEnabled = flags?.metricJobFunctionModalEnabled

  const shouldBypassModal =
    !modalEnabled ||
    metricsJobFunction ||
    organizationid !== own_organization_id ||
    organizationid === 1

  if (shouldBypassModal) {
    return null
  }

  const handleSubmit = async ({ validateOnMount, ...values }, { setSubmitting }) => {
    await dispatch(patchUser(userId, values))
    await dispatch(fetchCurrentUserPermissions(userId, organizationid))
    setSubmitting(false)
    dispatch(closeModal())
  }

  return (
    <BasicModal
      data-testid="metrics-job-function-modal"
      show={currentlyOpenModalId === 'metricsJobFunctionModal'}
      size="tiny"
      showCloseButton={false}
      hideHeader
      canCloseOnDimmerClick
      onClose={() => dispatch(closeModal())}
    >
      <h3 data-testid="metrics-job-function-modal-title">{`Let's get to know you.`}</h3>
      <p>{`We'll tailor your experience and help you get the most out of Balto.`}</p>

      <AbstractForm
        existingValues={{ first_name: firstName, last_name: lastName }}
        schema={[
          { name: 'first_name', type: 'text', label: 'First Name', required: true },
          { name: 'last_name', type: 'text', label: 'Last Name', required: true },
          {
            name: 'metrics_job_function',
            type: 'select',
            label: 'What is your job function?',
            options: jobFunctionOptions,
            required: true,
          },
        ]}
        onSubmit={handleSubmit}
        buttonLabel="Finish Setup"
      />
    </BasicModal>
  )
}

export const MetricsJobFunctionModal = withLDConsumer()(MetricsJobFunctionModalComponent)
